import {gql} from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const CREATE_CLUB = gql`
  mutation createClub($input: ClubInput!) {
    createClub(input: $input) {
      name
      address {
        country
        state
        city
      }
    }
  }
`;

export const UPDATE_CLUB = gql`
  mutation updateClub($clubId: ID!, $clubModify: ClubInput!) {
    updateClub(clubId: $clubId, clubModify: $clubModify) {
      name
      address {
        country
        state
        city
      }
    }
  }
`;

export const DELETE_CLUB = gql`
  mutation deleteClub($clubId: ID!) {
    deleteClub(clubId: $clubId) {
      name
    }
  }
`;
